import React from 'react';
import PropTypes from 'prop-types';

import {default as ReactModal} from 'react-modal';

import uuid4 from 'uuid/v4';

import classNames from 'classnames';

import ErrorBlock from 'components/ErrorBlock';

import {SubmitButtons} from './components';

import './styles.css';

const EXTRA_SMALL = 'extraSmall';
const SMALL = 'small';
const SUB_MEDIUM = 'subMedium';
const MEDIUM = 'medium';
const LARGE = 'large';

const DEFAULT_TYPE = MEDIUM;

const MODAL_TYPE_CLASS = {
  [DEFAULT_TYPE]: 'medium',
  [EXTRA_SMALL]: 'extraSmall',
  [SMALL]: 'small',
  [SUB_MEDIUM]: 'subMedium',
  [LARGE]: 'large',
  [MEDIUM]: 'medium'
};

class ModalHeader extends React.Component<any> {
  static contextTypes = {
    onClose: PropTypes.func
  };

  render() {
    const {onClose} = this.context;
    const {children, heading} = this.props;

    return (
      <header className="ModalHeader">
        {heading && <h3>{heading}</h3>}
        {children && <div>{children}</div>}
        <button className="closeButton" onClick={onClose} />
      </header>
    );
  }
}

const ModalErrors = ({errors}: any) => (
  <React.Fragment>
    {Object.values(errors).map(errorValue => (
      <ErrorBlock key={uuid4()}>{errorValue}</ErrorBlock>
    ))}
  </React.Fragment>
);

const ModalBody = ({children}: any) => (
  <div className="ModalBody">{children}</div>
);

const ModalFooter = ({children, className}: any) => (
  <div className={classNames(className, 'ModalFooter')}>{children}</div>
);

class Modal extends React.Component<any> {
  static Header = ModalHeader;
  static Errors = ModalErrors;
  static Body = ModalBody;
  static Footer = ModalFooter;

  static EXTRA_SMALL = EXTRA_SMALL;
  static SMALL = SMALL;
  static SUB_MEDIUM = SUB_MEDIUM;
  static MEDIUM = MEDIUM;
  static LARGE = LARGE;
  static SubmitButtons = SubmitButtons;

  getChildContext() {
    return {onClose: this.props.onClose};
  }

  static childContextTypes = {
    onClose: PropTypes.func
  };

  render() {
    const modalTypeClass =
      MODAL_TYPE_CLASS[this.props.type] || MODAL_TYPE_CLASS[DEFAULT_TYPE];
    /*
    Whether a modal is open or not should NOT be controlled by the show prop!
    Modals should display loading state while they fetch some data.
    When loading state is added this piece of code MUST be deleted and the show prop deprecated.
    */
    const {show} = this.props;

    return (
      <ReactModal
        isOpen={show}
        className={classNames(this.props.className, 'Modal', modalTypeClass)}
        overlayClassName={classNames(
          this.props.modalOverlayClassName,
          'ModalOverlay'
        )}>
        {this.props.children}
      </ReactModal>
    );
  }
}

export default Modal;
export * from './withModal';
